<div class="profi-neo-sync">
  <div class="header">
    <div class="title">
      <nb-icon pack="fas" icon="arrows-rotate"></nb-icon>
      Profi.neo Sanierung Synchronisierung
    </div>
  </div>

  @if (blockingReason(); as reason) {
    <wr-banner class="blocking-banner"
               status="warning"
               [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
               [message]="reason">
    </wr-banner>
  }

  <div class="kv">
    <div class="row">
      <div class="label">Status</div>
      <div class="value">
        @if (profiNeoSyncState(); as state) {
          <span class="status" [class]="'text-' + statusColorMap[state.syncStatus]">{{ state.syncStatus }}</span>
        } @else {
          <span class="muted">Nicht synchronisiert</span>
        }
      </div>
    </div>
    <div class="row">
      <div class="label">Letztes Sync-Datum</div>
      <div class="value">
        @if (profiNeoSyncState()?.lastSyncDate) {
          {{ profiNeoSyncState()?.lastSyncDate | date:'dd.MM.yyyy HH:mm' }}
        } @else {
          <span class="muted">—</span>
        }
      </div>
    </div>
    <div class="row">
      <div class="label">Profi.neo Kundennummer</div>
      <div class="value">
        @if (profiNeoSyncState()?.profiNeoLocationAddressId) {
          <code>{{ profiNeoSyncState()?.profiNeoLocationAddressId }}</code>
        } @else {
          <span class="muted">—</span>
        }
      </div>
    </div>
    <div class="row">
      <div class="label">Gebäudeteil-Kundennummern</div>
      <div class="value">
        @if (sectionAddressIds().length > 0) {
          <div class="section-address-ids">
            @for (addressId of sectionAddressIds(); track addressId) {
              <code>{{ addressId }}</code>
            }
          </div>
        } @else {
          <span class="muted">—</span>
        }
      </div>
    </div>
    <div class="row">
      <div class="label">Profi.neo Projektnummer</div>
      <div class="value">
        @if (profiNeoSyncState()?.profiNeoProjectId) {
          <code>{{ profiNeoSyncState()?.profiNeoProjectId }}</code>
        } @else {
          <span class="muted">—</span>
        }
      </div>
    </div>
  </div>

  <div class="footer">
    @if (isSynced()) {
      <div class="synced-hint">
        <nb-icon pack="fas" icon="check" status="success"></nb-icon>
        <span class="success-text">Bereits synchronisiert</span>
      </div>
    } @else if (canShowSyncButton()) {
      <button nbButton status="primary" (click)="synchronizeBuilding()" [disabled]="syncInProgress() || isBlocked()">
        @if (syncInProgress()) { <nb-icon pack="fas" icon="spinner" class="fa-spin leading-icon"></nb-icon> }
        <span>{{ syncInProgress() ? 'Synchronisieren…' : 'Jetzt synchronisieren' }}</span>
      </button>
    }
  </div>
</div>
